// Author Eric
// Date 2020-09-18 09:17:42

class SithMesAndonTaskSchedule {
constructor({
        id = null,
        andonTaskId = '',
        scheduleTime = '',
        status = '',
        andonPositionId = '',
        remark = ''}
= {}) {
    this.id = id;
    this.andonTaskId = andonTaskId;
    this.scheduleTime = scheduleTime;
    this.status = status;
    this.andonPositionId = andonPositionId;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesAndonTaskSchedule();
}

function gridFields() {
return Object.freeze([
        {
        key: 'andonTaskId',
        label: 'label.sith.andon.sithMesAndonTaskSchedule.grid.andonTaskId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'scheduleTime',
        label: 'label.sith.andon.sithMesAndonTaskSchedule.grid.scheduleTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'status',
        label: 'label.sith.andon.sithMesAndonTaskSchedule.grid.status',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'andonPositionId',
        label: 'label.sith.andon.sithMesAndonTaskSchedule.grid.andonPositionId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.andon.sithMesAndonTaskSchedule.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
]);
}

const filter = {
    andonTaskIdFilter : "",
    scheduleTimeRteFilter : "",
    scheduleTimeLteFilter : "",
    statusFilter : "",
    andonPositionIdFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'andonTaskIdFilter',
        label: 'label.sith.andon.sithMesAndonTaskSchedule.filter.andonTaskId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'scheduleTimeRteFilter',
        label: 'label.sith.andon.sithMesAndonTaskSchedule.filter.scheduleTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'scheduleTimeLteFilter',
        label: 'label.sith.andon.sithMesAndonTaskSchedule.filter.scheduleTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.sith.andon.sithMesAndonTaskSchedule.filter.status',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'andonPositionIdFilter',
        label: 'label.sith.andon.sithMesAndonTaskSchedule.filter.andonPositionId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'andonTaskId',
        label: 'label.sith.andon.sithMesAndonTaskSchedule.entity.andonTaskId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'scheduleTime',
        label: 'label.sith.andon.sithMesAndonTaskSchedule.entity.scheduleTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'status',
        label: 'label.sith.andon.sithMesAndonTaskSchedule.entity.status',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'andonPositionId',
        label: 'label.sith.andon.sithMesAndonTaskSchedule.entity.andonPositionId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.andon.sithMesAndonTaskSchedule.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesAndonTaskSchedule, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
